import { useEffect, useRef, useState } from "react";

/**
 * True once the element comes within `rootMargin` of the viewport, and from
 * then on: for a fetch that should start just before the element shows.
 */
export const useInViewOnce = <T extends Element>(rootMargin: string) => {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (inView) return;
    const el = ref.current;
    if (!el) return;

    // eslint-disable-next-line compat/compat -- IntersectionObserver is supported in all target browsers
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) setInView(true);
      },
      { rootMargin }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [inView, rootMargin]);

  return { ref, inView };
};
